function getLastSegment(title) {
    var parts = title.split(">");
    return parts[parts.length - 1].trim();
}

$(document).ready(function(){

	$('.expand .row2 .menumob ul li').each(function(){
		var title = $(this).attr('data-title');
		// si existe un .submenu51 con ese mismo data-title…
		if ($('.submenu51[data-title="' + title + '"]').length) {
		$(this).addClass('has-children');
		}
  	});
    var winW = $(window).width();
    
    // Inicialización: Ocultar todos los textos excepto el primero
    $(".header-top .col02 .texts > .text").hide();
    $(".header-top .col02 .texts > .text:first").show();
    
    // Función para cambiar el texto visible
    function cambiarTexto() {
        var $current = $('.header-top .col02 .texts > .text:visible');
        var $next = $current.next('.text');
        
        // Si no hay siguiente, reinicia al primero
        if ($next.length === 0) {
            $next = $('.header-top .col02 .texts > .text:first');
        }
        
        // Detiene animaciones en curso y realiza fadeOut
        $current.stop(true, true).fadeOut(1000, function() {
            // Después de fadeOut, realiza fadeIn del siguiente elemento
            $next.stop(true, true).fadeIn(1000, function(){
                // Mueve el elemento actual al final para mantener el ciclo
                $current.appendTo('.header-top .col02 .texts');
                // Programa la próxima animación después de fadeIn + tiempo de espera
                setTimeout(cambiarTexto, 5000);
            });
        });
    }
    
    // Inicia la primera animación después de 5 segundos
    setTimeout(cambiarTexto, 5000);
	// Topbar
	$('.header-top .col02 .text').click(function(){
		$('.topbar').addClass('show');
		$('.topbar .inner').addClass('show');
		$('body').addClass('locked');
	});
	$('.topbar .cerrar').click(function(e){
		e.preventDefault();
		$('.topbar').removeClass('show');
		$('.topbar .inner').removeClass('show');
		$('body').removeClass('locked');
	});

	// Menú principal (panel)
	$('.header2 .icons a.menu').click(function(e){
		e.preventDefault();
		$('.expand').addClass('show');
		$('.expand .row2').addClass('show');
		$('body').addClass('locked');
	});
	$('.expand .cerrar').click(function(e){
		e.preventDefault();
		$('.expand').removeClass('show');
		$('.expand .row2').removeClass('show');
		$('body').removeClass('locked');
	});

	// Primer nivel
	if(winW > 993){
		// Desktop: Primer nivel con .subcol[data-level="1"]
		$('.submenu51').appendTo('.header2');
		$('.submenu51 .cerrar').click(function(e){
			e.preventDefault();
			$('.submenu51').removeClass('show');
		});
		$('.submenu51').on('click', '.subcol:not([data-level]), .subcol[data-level="1"]', function(e){
			if(e.target === this) return; 
			if ($(e.target).is('a')) return;
			var $submenu = $(this).closest('.submenu51');
			var $menuDiv = $(this).find('.menu-div').first();
			var $header  = $(this).find('h4').first();
			if ($menuDiv.length) {
				e.preventDefault();
				if ($menuDiv.hasClass('show')) {
					$header.removeClass('active');
					if (!$submenu.find('.menu-div.show').length) {
						$submenu.find('> .cerrar').show();
						$submenu.removeClass('expanded');
					}
				} else {
					$submenu.find('.subcol h4').removeClass('active');
					$submenu.find('> .cerrar').hide();
					$submenu.find('.menu-div.show').not($menuDiv).each(function(){
						$(this).removeClass('show').find('.cerrar.cerrar-full').remove();
					});
					$menuDiv.addClass('show');
					$header.addClass('active');
					if (!$menuDiv.find('.cerrar.cerrar-full').length) {
						$menuDiv.prepend(`
							<svg class="cerrar cerrar-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
								<path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
							</svg>
						`);
					}
					$submenu.addClass('expanded');
				}
			}
		});
		$(document).on('click', '.menu-div .cerrar.cerrar-full', function(e){
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			var $div = $(this).closest('.menu-div');
			var curLevel = parseInt($div.attr('data-level'),10) || 1;
			$div.removeClass('show');
			$(this).remove();
			// Cierra TODOS los niveles anteriores (<= curLevel)
			$('.submenu51 .menu-div').filter(function(){
				return (parseInt($(this).attr('data-level'),10) || 1) <= curLevel;
			}).removeClass('show').find('.cerrar.cerrar-full').remove();
			if (!$('.submenu51 .menu-div.show').length) {
			$('.submenu51').removeClass('show expanded');
			}
			var dataTitle = $div.attr('data-title') || '';
			var parts = dataTitle.split('>');
			var child = parts.pop().trim();
			var parent = parts.join('>');
			var $li = $('li.has-children[data-target="'+ parent +'"]').filter(function(){
				return $(this).text().trim() === child;
			});
			if($li.length){ $li.removeClass('active'); }
			updateXButtons();
		});
	} else {
		$('.submenu51 h4 a').removeAttr('href');
		$('.submenu51').appendTo('.expand');
		$('.submenu51').prepend('<span class="back"><svg viewBox="0 0 30 30" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title>CTA Arrow</title><desc>CTA Arrow</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c-.4-.4-.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"/></svg></span>');
		$('.submenu51 .back').click(function(){
			$('.submenu51').removeClass('show');
			$('.expand .row2').addClass('show');
			$('.expand').removeClass('fix');
			$('.submenu51').scrollTop(0);
		});
		$('.expand .row2 .cols51 .col51 h3').each(function(){
			$(this).click(function(){
				$(this).toggleClass('active');
				$(this).siblings('ul').slideToggle(200);
			}); 
		});
	}
	
	$('.submenu51').on('click', 'li.has-children', function(e){
		if($(e.target).is('a')) return;
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		var $li = $(this);
		var parentTitle = $li.attr('data-target') || '';
		var childText = $li.text().trim();
		var nextTitle = parentTitle + (childText ? ('>' + childText) : '');
		var $div = $('.menu-div[data-title="' + nextTitle + '"]');
		if(!$div.length) return;
		var level = parseInt($div.attr('data-level'),10) || 1;
		for(var l = level; l <= 10; l++){
			$('.menu-div[data-level="'+ l +'"].show').not($div).each(function(){
				$(this).removeClass('show').find('.cerrar.cerrar-full').remove();
				const dataTitle = $(this).data('title');
				const child = getLastSegment(dataTitle);
				const parent = dataTitle.replace('>' + child, '').trim();
				$(`li.has-children[data-target="${parent}"]:contains('${child}')`).removeClass('active');
			});
		}
		if($div.hasClass('show')){
			$div.removeClass('show');
			$li.removeClass('active');
			$div.find('.cerrar.cerrar-full').remove();
		} else {
			$li.closest('ul').find('li.has-children.active').removeClass('active');
			$div.addClass('show');
			$li.addClass('active');
			if(winW <= 993 && !$div.find('u').length){
				$div.prepend('<u>' + getLastSegment($div.data("title")) + '</u>');
			}
		}
		updateXButtons();
	});
	
	// Handler global para la X en subniveles (ambos)
	$(document).on('click', '.menu-div .cerrar.cerrar-full', function(e){
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		var $div = $(this).closest('.menu-div');
		$div.removeClass('show');
		$(this).remove();
		var dataTitle = $div.attr('data-title') || '';
		var parts = dataTitle.split('>');
		var child = parts.pop().trim();
		var parent = parts.join('>');
		var $li = $('li.has-children[data-target="'+ parent +'"]').filter(function(){
			return $(this).text().trim() === child;
		});
		if($li.length){ $li.removeClass('active'); }
		// En desktop, cierra TODOS los niveles anteriores (<= nivel actual)
		if(winW > 993){
			$('.submenu51 .menu-div').filter(function(){
				return (parseInt($(this).attr('data-level'),10) || 1) <= (parseInt($div.attr('data-level'),10) || 1);
			}).removeClass('show').find('.cerrar.cerrar-full').remove();
			if (!$('.submenu51 .menu-div.show').length) {
			$('.submenu51').removeClass('show expanded');
			}
		}
		updateXButtons();
		if(winW <= 993){
			$('.submenu51').removeClass('show');
			$('.submenu51 .menu-div, .submenu51 .inner').removeClass('show');
			$('.expand').removeClass('show fix');
			$('body').removeClass('locked');
		}
	});
	
	function updateXButtons(){
		$('.menu-div.show').each(function(){
			var $div = $(this);
			var curLevel = parseInt($div.attr('data-level'),10) || 1;
			var higher = $('.menu-div.show').filter(function(){
				return (parseInt($(this).attr('data-level'),10) || 1) > curLevel;
			});
			if(higher.length > 0){
				$div.find('.cerrar.cerrar-full').remove();
			} else {
				if(!$div.find('.cerrar.cerrar-full').length){
					var svg = `
						<svg class="cerrar cerrar-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
							<path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
						</svg>
					`;
					if(winW <= 993 && $div.find('.back').length > 0){
						$div.find('.back').first().after(svg);
					} else {
						$div.prepend(svg);
					}
				}
			}
		});
	}
	
	if(winW <= 993){
		$('.submenu51 h4').each(function(){
			$(this).click(function(e){
				e.preventDefault();
				var fullTitle = $(this).next('.menu-div').data('title') || "";
				var h4title = getLastSegment(fullTitle);
				var fullTitle2 = $(this).next('.inner').data('title') || "";
				var h4title2 = getLastSegment(fullTitle2);
				$(this).next('.menu-div').addClass('show');
				$(this).next('.menu-div').prepend('<u>' + h4title + '</u>');
				$(this).next('.inner').addClass('show');
				$(this).next('.inner').prepend('<u>' + h4title2 + '</u>');
				if (!$(this).next('.menu-div').find('.cerrar').length) {
					$(this).next('.menu-div').prepend(`
						<a href="#" class="cerrar cerrar-full">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
							<path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
						</svg>
						</a>
					`);
				} else if (!$(this).next('.menu-div').find('.cerrar').hasClass('cerrar-full')) {
					$(this).next('.menu-div').find('.cerrar').addClass('cerrar-full');
				}
				updateXButtons();
			});
		});
		
		$('.menu-div').prepend('<span class="back"><svg viewBox="0 0 30 30" id="icon-back" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title>Back</title><desc>Back arrow</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c-.4-.4-.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"/></svg></span>');
		$('.menu-div .back').on('click', function(){
			$(this).closest('.menu-div').removeClass('show');
			$(this).closest('.menu-div').scrollTop(0);
			updateXButtons();
		});
		$('.submenu51 .inner').prepend('<span class="back"><svg viewBox="0 0 30 30" id="icon-back2" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title>Back</title><desc>Back arrow</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c-.4-.4-.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"/></svg></span>');
		$('.submenu51 .inner .back').on('click', function(){
			$('.submenu51 .inner').removeClass('show');
			$('.submenu51 .inner').scrollTop(0);
			updateXButtons();
		});
	}
	
	// Scroll header fixed
	var lastScrollTop = 0;
	$(window).scroll(function(){
		var st = $(this).scrollTop();
		if(st === 0){
			$('.header2, .product-sticky-menu').removeClass('fixed');
		} else {
			$('.header2').addClass('fixed');
			if(st > lastScrollTop){
				$('.product-sticky-menu').addClass('fixed');
			} else {
				$('.product-sticky-menu').removeClass('fixed');
			}
		}
		lastScrollTop = st;
	});
	
	// Evitar submit real
	const cartForms = document.querySelectorAll(".product_form.product_form_options");
	setTimeout(() => {
		cartForms.forEach(form => {
			form.addEventListener("submit", (e)=>{
				e.preventDefault();
			});
		});
	}, 500);
	
	// Registrar path en localStorage
	const pathname = window?.location?.pathname;
	const history = localStorage.getItem('@history');
	if(history){
		localStorage.setItem('@history', JSON.stringify([
			...JSON.parse(history),
			pathname
		]));
	} else {
		localStorage.setItem('@history', JSON.stringify([pathname]));
	}
});
